class SensorsdataMethods {
  eventName = "hw_exposure_event"

  config = {
    area_rate: 0.7,
    stay_duration: .4,
    repeated: false
  }

  globalProperties = {
    "language": localStorage.getItem('translation-lab-lang'),
    "site": "com",
    "device_os": navigator.userAgent,
    "region": localStorage.getItem('translation-lab-currency'),
    "account_ident": localStorage.getItem('account_ident'),
    "platform": util.isMobile() ? 'M' : 'PC'
  }

  exposureAttrConfig(eventName = 'hw_exposure_event', pagetype, pid) {
    return {
      "data-sensors-exposure-event-name": eventName,
      "data-sensors-exposure-property-language": "en",
      "data-sensors-exposure-property-site": "com",
      "data-sensors-exposure-property-page_type": pagetype,
      "data-sensors-exposure-property-product_id": pid,
      "data-sensors-exposure-property-device_os": navigator.userAgent,
      "data-sensors-exposure-property-region": localStorage.getItem('T4Currency'),
      "data-sensors-exposure-property-account_ident": localStorage.getItem('account_ident'),
      "data-sensors-exposure-property-var": '',
      "data-sensors-exposure-property-test_test": 'test-007',
    }
  }
  collectionProductExposure(elArr) {
    elArr.map((ind, item) => {
      $(item).attr('data-sensors-exposure-property-device_os', `${navigator.userAgent}`)
      $(item).attr('data-sensors-exposure-property-region', `${localStorage.getItem('T4Currency')}`)
      $(item).attr('data-sensors-exposure-property-account_ident', `${localStorage.getItem('account_ident')}`)
      $(item).attr('data-sensors-exposure-property-var', ``)
    })
  }

  clickProductEvent(eventName, config) {
    sensors.track(eventName, config);
  }
  wishListPageExposure() {
    if (!$('.uwl-product-iteam').length) {
      setTimeout(() => {
        this.wishListPageExposure()
      }, 0);
    }
    $('.uwl-product-iteam').map((ind, x) => {
      let ids = $(x).attr('id').split('-')
      exposure.addExposureView(x, {
        eventName: this.eventName,
        config: this.config,
        properties: {
          "product_id": ids[0],
          "var": ids[1],
          "page_type": 'wishlist',
          ...this.globalProperties
        }
      });
    })
  }

  productYMALExposure() {
    if (!$('.am_rec_item').length) {
      setTimeout(() => {
        this.productYMALExposure()
      }, 0);
    }
    $('.am_rec_item').map((ind, x) => {
      exposure.addExposureView(x, {
        eventName: this.eventName,
        config: this.config,
        properties: {
          "product_id": '',
          "var": $(x).find('select').val(),
          "page_type": 'prodyct-you_may_also_like',
          ...this.globalProperties
        }
      });
    })
  }

  searchPopup() {
    const elAll = document.getElementsByClassName('js-search-exposure');
    if (elAll.length) {
      for (let i = 0; i < elAll.length; i++) {
        elAll[i].setAttribute("data-sensors-exposure-event-name", "hw_exposure_event")
        elAll[i].setAttribute("data-sensors-exposure-property-device_os", navigator.userAgent)
        elAll[i].setAttribute("data-sensors-exposure-property-region", localStorage.getItem('T4Currency'))
        elAll[i].setAttribute("data-sensors-exposure-property-account_ident", localStorage.getItem('account_ident'))
        elAll[i].setAttribute("data-sensors-exposure-property-page_type", 'search')
        elAll[i].setAttribute("data-sensors-exposure-property-site", "com")
        elAll[i].setAttribute("data-sensors-exposure-property-language", "en")
        elAll[i].setAttribute("data-sensors-exposure-property-product_id", elAll[i].getAttribute('data-productid'))
        elAll[i].setAttribute("data-sensors-exposure-property-var", "")
        elAll[i].setAttribute("data-sensors-exposure-property-current_search_pp", "true")
      }
    } else {
      setTimeout(() => {
        this.searchPopup()
      }, 0);
    }
  }
}


(function () {

  var sa = new SensorsdataMethods();
  sa.collectionProductExposure($('.boost-pfs-filter-product-item'))
  if (location.href.indexOf('/apps/wishlist') > -1) {
    console.log('wishListPageExposure')
    sa.wishListPageExposure()
  }

  sa.searchPopup()

  // collection pro
  $('body').on('click', '.collection-template-boost-pfs-filter-row3 .boost-pfs-filter-product-item', function () {
    const config = {
      page_type: util.getPageType(),
      "product_id": $(this).attr('data-sensors-exposure-property-product_id'),
      "var": '',
      ...sa.globalProperties
    }
    sensors.track('hw_click_event', config);
  });

  // search pro
  $('body').on('click', '#shopify-section-search-template-boost-pfs-filter .boost-pfs-filter-product-item', function () {
    const config = {
      page_type: util.getPageType(),
      "product_id": $(this).attr('data-id'),
      "var": '',
      ...sa.globalProperties
    }
    sensors.track('hw_click_event', config);
  });

  // index pro
  $('body').on('click', '.hp04_content .swiper-slide ', function () {
    const config = {
      page_type: util.getPageType(),
      "product_id": $(this).find('.product').attr('data-productid'),
      "var": '',
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  });

  // product_recently_viewed
  $('body').on('click', '#shopify-section-recently_viewed .sa-product ', function (e) {
    const config = {
      page_type: 'product_recently_viewed',
      "product_id": $(this).attr('data-productid'),
      "var": '',
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  });

  // product_you_may_also_like
  $('body').on('click', '#shopify-section-product-recommendations .product', function () {
    const config = {
      page_type: 'product_you_may_also_like',
      "product_id": $(this).attr('data-productid'),
      "var": '',
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  });

  // product-frequently-bought-together pro
  $('body').on('click', '.fbt_container .swiper-slide', function () {
    const config = {
      page_type: 'product-frequently-bought-together',
      "product_id": $(this).find('.product').attr('data-productid'),
      "var": '',
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  });

  // wishlist 
  $('body').on('click', '.uwl-product-iteam', function () {
    let ids = $(this).attr('id').split('-')
    const config = {
      page_type: util.getPageType(),
      "product_id": ids[0],
      "var": ids[1],
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  });

  // $('body.template-index').on('click', '.img-wrap, .url_text', function () {
  //   const config = {
  //     page_type: util.getPageType(),
  //     "entrance_name": $(this).data('sensorsExposurePropertyEntrance_name'),
  //     "entrance_url": $(this).data('sensorsExposurePropertyEntrance_url'),
  //     "entrance_type": $(this).data('sensorsExposurePropertyEntrance_type'),
  //     ...sa.globalProperties
  //   };
  //   sensors.track('hw_click_entrance', config);
  // })

  $('body').on('click', '.js-search-exposure', function () {
    const config = {
      page_type: 'search',
      "product_id": $(this).attr('data-productid'),
      "var": '',
      'current_search_pp': 'true',
      ...sa.globalProperties
    };
    sensors.track('hw_click_event', config);
  })

  $(document).on('click', '.hp01_content .img-wrap, .hp02_content .img-wrap, .hp03_content .img-wrap, .hp05_content .img-wrap, .hp06_content .img-wrap', function () {
    const config = {
      page_type: 'home',
      image_url: $(this).attr('data-sensors-exposure-property-image_url'),
      nt_sid: $(this).attr('data-sensors-exposure-property-nt_sid'),
      ...sa.globalProperties
    };
    debugger
    sensors.track('hw_click_image', config);
  })

  $(document).on('click', '.SlideshowWrapper .slideshow__slide', function () {
     let image_url = util.isMobile() ? $(this).find('.img_slider_block.mb_img_slide div').attr('data-sensors-exposure-property-image_url'):$(this).find('.img_slider_block.dek_img_slide div').attr('data-sensors-exposure-property-image_url')
    const config = {
      page_type: 'home',
      nt_sid: 'home_banner',
      image_url,
      ...sa.globalProperties
    };
    debugger
    sensors.track('hw_click_image', config);
  })
  
  $(document).on('click', '.hp01_content .url_text, .hp01_content .content_url_text, .hp02_content .text_url, .hp03_content .url_text, .hp05_content .url_text, .hp06_content .url_text', function () {
    const config = {
      page_type: 'home',
      text: $(this).attr('data-sensors-exposure-property-text'),
      landing_url_path: $(this).attr('data-sensors-exposure-property-landing_url_path'),
      nt_sid: $(this).attr('data-sensors-exposure-property-nt_sid'),
      ...sa.globalProperties
    };
    sensors.track('hw_click_ctaText', config);
  })


  $(document).on('click', '.finder_my_size__mo', function () {
    const config = {
      page_type: 'product',
      element_name: 'text_FindMySize',
      ...sa.globalProperties,
      platform: 'M'
    };
    sensors.track('hw_click_element', config);
  })
  $(document).on('click', '.finder_my_size__pc', function () {
    const config = {
      page_type: 'product',
      element_name: 'text_FindMySize',
      ...sa.globalProperties,
      platform: 'PC'
    };
    sensors.track('hw_click_element', config);
  })
  $(document).on('click', '.pro_detail_guide', function () {
    const config = {
      page_type: 'product',
      element_name: 'text_SizeGuide',
      ...sa.globalProperties,
    };
    sensors.track('hw_click_element', config);
  })
    $(document).on('click', '.size_guide_copy', function () {
    const config = {
      page_type: 'product',
      element_name: 'text_SizeGuide',
      ...sa.globalProperties,
    };
    sensors.track('hw_click_element', config);
  })
  $(document).on('click', '.next-step', function () {
    const config = {
      page_type: 'product_SizeRec',
      element_name: 'button_FindMySize',
      ...sa.globalProperties,
    };
    sensors.track('hw_click_element', config);
  })
})()
